module.exports = __webpack_public_path__ + "media/plans/large-83ccdadc.png";